import { useAmenityTypeContext } from '@/pages/amenity-types/useAmenityTypeContext';
import { EmptyTableState, Loading, RichTextContent } from '@startupquickstart/frontend';
import { FileText } from 'lucide-react';
import { formatDate } from '@startupquickstart/frontend';

export function AmenityTypeOverviewTab() {
  const { amenityType, isLoading } = useAmenityTypeContext();

  if (isLoading) {
    return (
      <div className="flex justify-center py-12">
        <Loading />
      </div>
    );
  }

  if (!amenityType) return null;

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
        {/* Left column */}
        <div className="lg:col-span-3 space-y-6">
          {/* About card */}
          <div className="rounded-xl border bg-card shadow-sm">
            <div className="px-6 py-4 border-b">
              <h2 className="text-lg font-medium tracking-tight text-zinc-900">About</h2>
              <p className="text-sm text-muted-foreground">
                Amenity type description and details
              </p>
            </div>
            <div className="p-6">
              {amenityType.description ? (
                <RichTextContent content={amenityType.description} />
              ) : (
                <EmptyTableState
                  icon={<FileText className="h-6 w-6" />}
                  title="No description"
                  description="Edit to add a description"
                />
              )}
            </div>
            <div className="border-t px-6 py-4 text-sm text-muted-foreground flex flex-wrap gap-x-6 gap-y-1">
              <span>Created: {formatDate(amenityType.createdAt)}</span>
              <span>Updated: {formatDate(amenityType.updatedAt)}</span>
            </div>
          </div>
        </div>

        {/* Right column */}
        <div className="lg:col-span-2 space-y-6">
          {/* Details card */}
          <div className="rounded-xl border bg-card shadow-sm">
            <div className="px-6 py-4 border-b">
              <h2 className="text-lg font-medium tracking-tight text-zinc-900">Details</h2>
              <p className="text-sm text-muted-foreground">Amenity type information</p>
            </div>
            <div className="p-6">
              <div className="divide-y">
                <div className="py-3 first:pt-0">
                  <div className="text-xs font-medium uppercase tracking-wider text-muted-foreground mb-0.5">
                    Name
                  </div>
                  <div className="text-sm">{amenityType.name}</div>
                </div>
                <div className="py-3">
                  <div className="text-xs font-medium uppercase tracking-wider text-muted-foreground mb-0.5">
                    ID
                  </div>
                  <div className="text-sm font-mono text-muted-foreground">{amenityType.id}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
